import React from "react";

import { Tooltip } from "@mui/material";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { Wrapper, Label, ValueEmpty, Value, ValueArrayWrapper } from "./styles";

interface FieldViewProps {
  label?: string;
  tooltip?: string;
  value?: string | Array<string>;
  valueClass?: string;
  "data-cy"?: string;
}

export default function FieldView(props: FieldViewProps) {
  const { label, value = "", valueClass, tooltip, ...rest } = props;
  const { t: translate } = useTranslation();

  const renderEmptyInfo = () => {
    return <ValueEmpty>{translate("empty")}</ValueEmpty>;
  };

  const renderArray = () => {
    if (value instanceof Array && value && value.length) {
      if (tooltip) {
        const newArray: string[] = [...value, `${tooltip.split(",").length} more`];

        return newArray.map((item, index: number) => (
          <>
            {index === newArray.length - 1 ? (
              <Tooltip title={tooltip} placement="top">
                <Value className={classnames(valueClass)}>{item}</Value>
              </Tooltip>
            ) : (
              <Value key={item} className={classnames(valueClass)}>
                {item}
              </Value>
            )}
          </>
        ));
      }

      return value.map((item) => (
        <Value key={item} className={classnames(valueClass)}>
          {item}
        </Value>
      ));
    }

    return "";
  };

  const renderValue = () => {
    if (value instanceof Array && value && value.length) {
      return <ValueArrayWrapper>{renderArray()}</ValueArrayWrapper>;
    }

    if (!value) return renderEmptyInfo();

    return <Value className={classnames(valueClass)}>{value}</Value>;
  };

  return (
    <Wrapper {...rest}>
      {label ? <Label>{label}</Label> : null}
      {renderValue()}
    </Wrapper>
  );
}
